const jobs = [{ id: 0 }];

export default jobs;
